<template>
  <div class="driver-bookings transporter-driver-bookings">
    <FilterBoard
      class="driver-bookings-filter-row oms-list-filter"
      :show-heading="false"
      eyebrow=""
      title=""
    >
      <v-flex
        xs12
        sm6
        md2
        class="oms-filter-board__field driver-bookings-filter-field--type"
      >
        <v-select
          v-model="searchTypes"
          :items="searchItems"
          label="Search Type"
          item-text="status"
          single-line
          item-value="abbr"
          @change="searchByType()"
          return-object
          hide-details
          outline
        ></v-select>
      </v-flex>
      <v-flex
        xs12
        sm6
        md3
        class="oms-filter-board__field oms-filter-board__field--search driver-bookings-filter-field--search"
      >
        <v-text-field
          class="inputSearch"
          label="Search here.."
          type="number"
          outline
          :disabled="!searchTypes"
          single-line
          v-model="searchText"
          @keyup.enter="searchAnything"
          @click:append="searchAnything"
          append-icon="search"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex
        xs12
        sm6
        md3
        class="oms-filter-board__field driver-bookings-filter-field--status"
      >
        <v-autocomplete
          v-model="select"
          :items="AssignmentStatus"
          item-text="status"
          item-value="abbr"
          multiple
          label="Filter by Assignment Status"
          single-line
          outline
          hide-details
          class="driver-bookings-status-filter"
          @change="filterByAssignmentStatus"
        ></v-autocomplete>
      </v-flex>
      <v-flex
        xs12
        sm6
        md3
        class="wrapper oms-filter-board__field oms-filter-board__field--date driver-bookings-filter-field--date"
        id="jobDate"
      >
        <ejs-daterangepicker
          :placeholder="waterMark"
          v-model="dateRange"
        ></ejs-daterangepicker>
      </v-flex>
      <v-flex
        xs12
        sm6
        md1
        class="reset-btn oms-filter-board__actions driver-bookings-filter-field--reset"
      >
        <v-btn
          class="reset-btn-color oms-filter-board__reset"
          flat
          prepend-icon
          color="orange darken-1"
          @click.native="reset()"
        >
          Reset
          <v-icon color="orange">donut_large</v-icon>
        </v-btn>
      </v-flex>
    </FilterBoard>

    <ScrollableTable
      ref="tableScroll"
      class="transporter-driver-bookings-scroll oms-list-table-scroll"
      min-width="100%"
    >
      <v-data-table
        class="transporter-driver-bookings-table oms-list-table"
        hide-actions
        :headers="headers"
        :items="items"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <td>
            <div class="transporter-drivers-stack">
              <span class="transporter-drivers-stack__main">{{
                props.item.jobId
              }}</span>
              <span class="transporter-drivers-stack__sub">{{
                getTime(props.item.startDate)
              }}</span>
            </div>
          </td>
          <td>
            <div class="transporter-drivers-stack">
              <span class="transporter-drivers-stack__main">{{
                props.item.assignmentId
              }}</span>
              <span
                class="transporter-drivers-pill"
                :class="statusTone(props.item.assignmentStatus)"
                >{{ getStatus(props.item.assignmentStatus) }}</span
              >
            </div>
          </td>
          <td>
            <div class="transporter-drivers-stack">
              <span>{{ props.item.ownerType || "-" }}</span>
              <span class="transporter-drivers-stack__sub">{{
                assignedTo(props.item)
              }}</span>
            </div>
          </td>
          <td>
            <div class="transporter-driver-bookings-route">
              <span>{{
                getLocation(props.item.sourceLocation, props.item.sourceCity)
              }}</span>
              <v-icon small class="transporter-driver-bookings-route__arrow"
                >arrow_downward</v-icon
              >
              <span>{{
                getLocation(
                  props.item.destinationLocation,
                  props.item.destinationCity
                )
              }}</span>
            </div>
          </td>
          <td>
            <div class="transporter-drivers-stack">
              <span
                class="transporter-drivers-stack__main transporter-drivers-vehicle"
                >{{ vehicleNumber(props.item) }}</span
              >
              <span
                v-if="props.item.truckType"
                class="transporter-drivers-stack__sub"
                >{{ props.item.truckType }}</span
              >
            </div>
          </td>
          <td class="transporter-driver-bookings-price">
            {{
              props.item.paymentAmount
                ? $formatPrice(props.item.paymentAmount) +
                  " " +
                  props.item.paymentCurrency
                : "-"
            }}
          </td>
          <td>
            <v-menu
              v-if="props.item.wayBillNo"
              transition="slide-x-transition"
              offset-y
            >
              <v-btn
                slot="activator"
                icon
                small
                flat
                class="transporter-driver-bookings-icon-btn"
                title="Waybill"
              >
                <v-icon size="18">receipt</v-icon>
              </v-btn>
              <v-list dense>
                <template v-if="countrySortName != 'PAK'">
                  <v-list-tile
                    :to="`/assignments/${props.item.assignmentId}/UAE/waybill`"
                    target="_blank"
                  >
                    <v-list-tile-title>UAE</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="`/assignments/${props.item.assignmentId}/UAE/waybill`"
                    target="_blank"
                  >
                    <v-list-tile-title>UAE LA</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="`/assignments/${props.item.assignmentId}/UAE/waybill`"
                    target="_blank"
                  >
                    <v-list-tile-title>KSA</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="`/assignments-old/${props.item.assignmentId}/KSA/waybill`"
                    target="_blank"
                  >
                    <v-list-tile-title>KSA Old</v-list-tile-title>
                  </v-list-tile>
                </template>
                <v-list-tile
                  v-else
                  :to="`/assignments/${props.item.assignmentId}/PAK/waybill`"
                  target="_blank"
                >
                  <v-list-tile-title>PAK</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <span v-else class="transporter-drivers-stack__sub">-</span>
          </td>
          <td>
            <ProofOfDeliveryForDriverBooking
              :assignmentId="props.item._id"
              :status="props.item.assignmentStatus"
              @error="error = 'No proof of delivery uploaded yet'"
            />
          </td>
          <td>
            <button
              type="button"
              class="track-ass-btn"
              @click="goToProfile(props.item.jobId)"
            >
              View Job
            </button>
          </td>
        </template>
        <template slot="no-data">
          <span class="transporter-drivers-empty">
            {{ loading ? "Loading bookings..." : "No bookings found" }}
          </span>
        </template>
      </v-data-table>
    </ScrollableTable>
    <div class="transporter-drivers-pagination">
      <span class="transporter-drivers-pagination__summary">{{
        paginationSummary
      }}</span>
      <v-pagination
        v-if="totalPages > 0"
        :value="currentPage"
        :length="totalPages"
        :total-visible="7"
        :disabled="loading"
        circle
        @input="goToPage"
      />
    </div>

    <v-snackbar
      :timeout="3000"
      bottom
      color="red darken-2"
      v-model="error"
      class="white--text"
      v-if="error"
      >{{ error }}</v-snackbar
    >
  </div>
</template>

<script>
import moment from "moment";
import { driverassignmentListTrans } from "@/constants/datatable-headers.js";
import { driver } from "@/constants/api-urls";
import { StorageKeys } from "@/constants/constants";
import ProofOfDeliveryForDriverBooking from "@/components/Pop-ups/ProofOfDeliveryForDriverBooking";
import ScrollableTable from "@/components/Common/ScrollableTable";
import FilterBoard from "@/components/Common/FilterBoard";
import { EventBus } from "../../event-bus.js";

const PAGE_SIZE = 15;

const ASSIGNMENT_STATUS = {
  1: { label: "Driver Not Assigned", tone: "unverified" },
  2: { label: "Driver Assigned", tone: "info" },
  3: { label: "Payment Pending", tone: "assigned" },
  4: { label: "Payment Done", tone: "verified" },
  5: { label: "In-Transit", tone: "info" },
  6: { label: "Shipment Offloaded", tone: "verified" },
  "-1": { label: "Job Cancelled", tone: "danger" },
};

export default {
  created() {
    if (localStorage.getItem("workingCountries")) {
      let workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      workingCountries.forEach((key) => {
        if (key.isSelected) {
          this.countrySortName = key.value;
        }
      });
    }
    EventBus.$on("countryChanged", this.onCountryChanged);
    this.fetchBookings();
  },
  beforeDestroy() {
    EventBus.$off("countryChanged", this.onCountryChanged);
  },
  components: {
    ProofOfDeliveryForDriverBooking,
    ScrollableTable,
    FilterBoard,
  },
  data() {
    return {
      countrySortName: "",
      error: null,
      loading: false,
      bookingsRequestId: 0,
      select: [],
      payload: this.defaultPayload(),
      headers: driverassignmentListTrans,
      searchItems: [
        { status: "Job ID", abbr: "jobId" },
        { status: "Assignment ID", abbr: "assignId" },
      ],
      AssignmentStatus: [
        { status: "Driver Assigned", abbr: 2 },
        { status: "Payment Pending", abbr: 3 },
        { status: "Payment Done", abbr: 4 },
        { status: "In-Transit", abbr: 5 },
        { status: "Shipment Offloaded", abbr: 6 },
        { status: "Job Cancelled", abbr: -1 },
      ],
      items: [],
      totalBookings: 0,
      searchTypes: "",
      searchText: "",
      waterMark: "Select a Range",
      dateRange: null,
    };
  },
  computed: {
    currentPage() {
      return Math.floor(Number(this.payload.skip || 0) / PAGE_SIZE) + 1;
    },
    totalPages() {
      return Math.ceil(this.totalBookings / PAGE_SIZE);
    },
    paginationSummary() {
      if (!this.totalBookings) {
        return this.loading ? "" : "No bookings";
      }
      const from = Number(this.payload.skip || 0) + 1;
      const to = from + this.items.length - 1;
      const noun = this.totalBookings === 1 ? "booking" : "bookings";
      return `Showing ${from}-${to} of ${this.totalBookings} ${noun}`;
    },
  },
  watch: {
    payload: {
      handler() {
        this.fetchBookings();
      },
      deep: true,
    },
    dateRange(val) {
      this.payload.skip = "0";
      if (val && val[0] && val[1]) {
        this.$set(this.payload, "startDate", moment(val[0]).format("YYYY-MM-DD"));
        this.$set(this.payload, "endDate", moment(val[1]).format("YYYY-MM-DD"));
        return;
      }
      this.$delete(this.payload, "startDate");
      this.$delete(this.payload, "endDate");
    },
  },
  methods: {
    defaultPayload() {
      return {
        skip: "0",
        limit: String(PAGE_SIZE),
        driverId: this.$route.params.id,
        transporterId: this.$route.params._id,
      };
    },
    fetchBookings() {
      const requestId = ++this.bookingsRequestId;
      this.loading = true;
      delete this.axios.defaults.headers.common["token"];
      const token = localStorage.getItem(StorageKeys.SessionKey);
      const config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.axios
        .post(this.constants.apiUrl + driver.driverAssignment, this.payload, config)
        .then(
          (response) => {
            // A newer filter or page change superseded this request.
            if (requestId !== this.bookingsRequestId) return;
            const { list = [], totalData = 0 } = response.data.data || {};
            this.items = list;
            this.totalBookings = totalData;
            this.loading = false;
            const scroll = this.$refs.tableScroll;
            if (scroll && scroll.$el) scroll.$el.scrollTop = 0;
          },
          (error) => {
            if (requestId !== this.bookingsRequestId) return;
            this.items = [];
            this.totalBookings = 0;
            this.loading = false;
            this.error =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              "Failed to fetch bookings";
          }
        );
    },
    onCountryChanged() {
      if (this.$route.name == "transporter-driver-detail-assignments") {
        this.$router.push(`/transporter`);
      }
    },
    goToPage(page) {
      this.$set(this.payload, "skip", String((page - 1) * PAGE_SIZE));
    },
    goToProfile(jobId) {
      this.$router.push(`/jobs/${jobId}`);
    },
    getTime(time) {
      return time ? moment.unix(time).format("DD MMM YYYY") : "-";
    },
    getStatus(status) {
      const entry = ASSIGNMENT_STATUS[status];
      return entry ? entry.label : "Unknown";
    },
    statusTone(status) {
      const entry = ASSIGNMENT_STATUS[status];
      return `transporter-drivers-pill--${entry ? entry.tone : "unverified"}`;
    },
    assignedTo(item) {
      if (item.vendorName) return item.vendorName;
      return item.transporterData
        ? item.transporterData.transporterName
        : "N.A";
    },
    vehicleNumber(item) {
      if (!item.truckNumber) return "-";
      if (!item.truckPrefix || item.truckPrefix == "Others") {
        return item.truckNumber;
      }
      return `${item.truckPrefix}-${item.truckNumber}`;
    },
    getLocation(...parts) {
      return parts.filter(Boolean).join(", ") || "-";
    },
    filterByAssignmentStatus() {
      this.payload.skip = "0";
      if (this.select.length) {
        this.$set(this.payload, "assignStatus", this.select);
        return;
      }
      this.$delete(this.payload, "assignStatus");
    },
    searchByType() {
      this.searchText = "";
      this.searchAnything();
    },
    searchAnything() {
      const text = String(this.searchText || "").trim();
      this.payload.skip = "0";
      if (text && this.searchTypes) {
        this.$set(this.payload, "searchType", this.searchTypes.abbr);
        this.$set(this.payload, "searchText", text);
        return;
      }
      this.$delete(this.payload, "searchType");
      this.$delete(this.payload, "searchText");
    },
    reset() {
      this.searchText = "";
      this.searchTypes = "";
      this.select = [];
      this.dateRange = null;
      this.payload = this.defaultPayload();
    },
  },
};
</script>

<style lang="scss" scoped>
.inputSearch ::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
.inputSearch ::v-deep input::-webkit-outer-spin-button,
.inputSearch ::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
